import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\LessonController::date
* @see app/Http/Controllers/LessonController.php:25
* @route '/teacher/lessons/{schedule}/{date}'
*/
export const date = (args: { schedule: string | number, date: string | number } | [schedule: string | number, date: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: date.url(args, options),
    method: 'get',
})

date.definition = {
    methods: ["get","head"],
    url: '/teacher/lessons/{schedule}/{date}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LessonController::date
* @see app/Http/Controllers/LessonController.php:25
* @route '/teacher/lessons/{schedule}/{date}'
*/
date.url = (args: { schedule: string | number, date: string | number } | [schedule: string | number, date: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
            date: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: args.schedule,
        date: args.date,
    }

    return date.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace('{date}', parsedArgs.date.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LessonController::date
* @see app/Http/Controllers/LessonController.php:25
* @route '/teacher/lessons/{schedule}/{date}'
*/
date.get = (args: { schedule: string | number, date: string | number } | [schedule: string | number, date: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: date.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LessonController::date
* @see app/Http/Controllers/LessonController.php:25
* @route '/teacher/lessons/{schedule}/{date}'
*/
date.head = (args: { schedule: string | number, date: string | number } | [schedule: string | number, date: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: date.url(args, options),
    method: 'head',
})

const show = {
    date: Object.assign(date, date),
}

export default show